import { clientPromise } from '../../../../http/apollo.config';
import { CHECK_USER_EXISTS } from '../../../../http/apollo-queries';

let checkCount = 0;
const maxCheckCount = 30;

export const EmailUsernameValidator = (email: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!email) {
    return 'Required';
  } else if (!re.test(String(email).toLowerCase())) {
    return 'Invalid';
  } else if (checkCount > maxCheckCount) {
    return 'TooManyCheck';
  } else {
    checkCount++;
    return clientPromise
      .then((client) =>
        client
          .query({ query: CHECK_USER_EXISTS, variables: { email } })
          .then((res) => {
            return res.data?.checkUserExist?.status === 'SUCCESS'
              ? 'AlreadyExist'
              : null;
          })
      )
      .catch(() => {
        return 'Error';
      });
  }
};
